<form [formGroup]="searchForm" (ngSubmit)="onFormSubmit()">
    <div class="container-form">
        <div class="row-search">
            <mat-form-field class="field widthClientName">
                <mat-label>{{ 'certificates.clientNameRequest' | translate }}</mat-label>
                <input matInput formControlName="creatorName">
                <button *ngIf="searchForm.get('creatorName')?.value" matSuffix mat-icon-button
                    (click)="clearField('creatorName')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="line">
                <mat-label>{{ 'certificates.fromDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="fromDate" formControlName="fromDate" [max]="fromDateMax">
                <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
                <button *ngIf="searchForm.get('fromDate')?.value" matSuffix mat-icon-button
                    (click)="clearField('fromDate')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
                <mat-datepicker #fromDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="line">
                <mat-label>{{ 'certificates.toDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="toDate" formControlName="toDate" [min]="toDateMin">
                <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
                <button *ngIf="searchForm.get('toDate')?.value" matSuffix mat-icon-button
                    (click)="clearField('toDate')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
                <mat-datepicker #toDate></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
    <div class="action-buttons">
        <button mat-button type="submit" class="mat-mdc-raised-button">{{ 'certificates.searchCertificates' |
            translate }}</button>
        <button mat-button (click)="resetFilters()" type="button" class="mat-mdc-raised-button">{{
            'certificates.resetFilters' | translate
            }}</button>
        <button mat-button (click)="exportExcel()" [disabled]="!hasData()" type="button"
            class="mat-mdc-raised-button">{{
            'certificates.exportExcel' | translate }}</button>
    </div>
</form>
<div class="no-content-message">
    {{this.emptyMassage}}
</div>
<div class="spinner-container" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<cloud-business-management-requests-report-qes-table *ngIf="showTable" [managementRequests]="managementRequests" [loading]="loading"
    [totalCount]="totalCount" [pageSize]="currentPagination.pageSize" [pageIndex]="currentPagination.pageIndex"
    [activeSort]="currentSorting.active" [sortDirection]="currentSorting.direction" (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)">
</cloud-business-management-requests-report-qes-table>